import { defineComponent as R, inject as z, computed as d, h as l } from "vue";
import { configProviderInjectionKey as I } from "./ghl-ui.es949.js";
import _ from "./ghl-ui.es1008.js";
import P from "./ghl-ui.es854.js";
import u from "./ghl-ui.es855.js";
import E from "./ghl-ui.es1009.js";
import b from "./ghl-ui.es919.js";
import D from "./ghl-ui.es1010.js";
import { createKey as a } from "./ghl-ui.es384.js";
import { useThemeClass as S } from "./ghl-ui.es857.js";
import $ from "./ghl-ui.es862.js";
const j = Object.assign(Object.assign({}, u.props), {
  description: String,
  showDescription: {
    type: Boolean,
    default: !0
  },
  showIcon: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    default: "medium"
  },
  renderIcon: Function
}), q = R({
  name: "Empty",
  props: j,
  setup(e) {
    const {
      mergedClsPrefixRef: n,
      inlineThemeDisabled: i
    } = P(e), p = u("Empty", "-empty", _, E, e, n), {
      localeRef: f
    } = b("Empty"), r = z(I, null), v = d(() => {
      var o, t, c;
      return (o = e.description) !== null && o !== void 0 ? o : (c = (t = r == null ? void 0 : r.mergedComponentPropsRef.value) === null || t === void 0 ? void 0 : t.Empty) === null || c === void 0 ? void 0 : c.description;
    }), h = d(() => {
      var o, t;
      return ((t = (o = r == null ? void 0 : r.mergedComponentPropsRef.value) === null || o === void 0 ? void 0 : o.Empty) === null || t === void 0 ? void 0 : t.renderIcon) || (() => l(D, null));
    }), m = d(() => {
      const {
        size: o
      } = e, {
        common: {
          cubicBezierEaseInOut: t
        },
        self: {
          [a("iconSize", o)]: c,
          [a("fontSize", o)]: y,
          textColor: g,
          iconColor: C,
          extraTextColor: x
        }
      } = p.value;
      return {
        "--n-icon-size": c,
        "--n-font-size": y,
        "--n-bezier": t,
        "--n-text-color": g,
        "--n-icon-color": C,
        "--n-extra-text-color": x
      };
    }), s = i ? S("empty", d(() => {
      let o = "";
      const {
        size: t
      } = e;
      return o += t[0], o;
    }), m, e) : void 0;
    return {
      mergedClsPrefix: n,
      mergedRenderIcon: h,
      localizedDescription: d(() => v.value || f.value.description),
      cssVars: i ? void 0 : m,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    const {
      $slots: e,
      mergedClsPrefix: n,
      onRender: i
    } = this;
    return i == null || i(), l("div", {
      class: [`${n}-empty`, this.themeClass],
      style: this.cssVars
    }, this.showIcon ? l("div", {
      class: `${n}-empty__icon`
    }, e.icon ? e.icon() : l($, {
      clsPrefix: n
    }, {
      default: this.mergedRenderIcon
    })) : null, this.showDescription ? l("div", {
      class: `${n}-empty__description`
    }, e.default ? e.default() : this.localizedDescription) : null, e.extra ? l("div", {
      class: `${n}-empty__extra`
    }, e.extra()) : null);
  }
});
export {
  q as default,
  j as emptyProps
};
